"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.requirementDefinitionFilterSchema = void 0;
const QueryBuilder_1 = require("../QueryBuilder");
exports.requirementDefinitionFilterSchema = (0, QueryBuilder_1.createFilterSchema)({
    fields: {
        slug: {
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
            description: 'Base slug for the requirement definition.',
        },
        slugPrefix: {
            options: { type: QueryBuilder_1.FieldType.String },
            description: 'Explicit result-slug display prefix for the requirement definition.',
        },
        description: {
            options: { type: QueryBuilder_1.FieldType.String, nonNullable: true },
            description: 'Free-text description of the requirement.',
        },
        createdAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row creation timestamp.',
        },
        updatedAt: {
            options: { type: QueryBuilder_1.FieldType.Date },
            description: 'Row update timestamp.',
        },
    },
});
//# sourceMappingURL=definition-filter-schema.js.map